(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity buttons
  document.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const input = document.querySelector(`.cart-item__qty-input[data-key="${key}"]`);
      const action = btn.dataset.action;
      let value = parseInt(input.value);

      if (action === 'decrease' && value > 0) {
        input.value = value - 1;
      } else if (action === 'increase') {
        input.value = value + 1;
      }
    });
  });

  // Fade in
  const animated = document.querySelectorAll('[data-animate]');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.1 });
  animated.forEach(el => observer.observe(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-header]');

  if (header) {
    const onScroll = () => {
      if (window.scrollY > 100) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  // Fade in on load
  const animatedElements = document.querySelectorAll('[data-animate]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.1 });

  animatedElements.forEach((el) => observer.observe(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Thumbnail gallery
  const thumbs = document.querySelectorAll('.product__thumbnail');
  const imgs = document.querySelectorAll('.product__image');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const i = thumb.dataset.index;
      thumbs.forEach(t => t.classList.remove('is-active'));
      imgs.forEach(img => img.classList.remove('is-active'));
      thumb.classList.add('is-active');
      imgs[i].classList.add('is-active');
    });
  });

  // Quantity
  const qtyInput = document.querySelector('.product__qty-input');
  const decBtn = document.querySelector('[data-action="decrease"]');
  const incBtn = document.querySelector('[data-action="increase"]');

  if (decBtn && incBtn && qtyInput) {
    decBtn.addEventListener('click', () => {
      const v = parseInt(qtyInput.value);
      if (v > 1) qtyInput.value = v - 1;
    });
    incBtn.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });
  }

  // Fade in
  const animated = document.querySelectorAll('[data-animate]');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.1 });
  animated.forEach(el => observer.observe(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-preview"] && !Shopify.designMode) return;
  try {
    
  const carousel = document.querySelector('[data-quote-carousel]');
  if (carousel) {
    const quotes = carousel.querySelectorAll('.quote-preview__quote');
    const dots = document.querySelectorAll('.quote-preview__dot');
    let current = 0;
    let timer;

    const show = (i) => {
      quotes.forEach((q, idx) => q.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      current = i;
    };

    const next = () => show((current + 1) % quotes.length);

    const start = () => { timer = setInterval(next, 6000); };
    const reset = () => { clearInterval(timer); start(); };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { show(i); reset(); });
    });

    start();
  }

  } catch(e) { console.error(e); }
})();
})();
